import { METALS } from '../types';
import { capitalized } from '../utils';
import { Item } from './Item';

interface BORDERED_LIST_PROPS {
  list: string[];
  activeValue: string;
  basePath: string;
  metal: METALS;
}

const BorderedList = ({
  list,
  activeValue,
  basePath,
  metal,
}: BORDERED_LIST_PROPS): JSX.Element => {
  return (
    <div className="border border-grey-225 rounded-md mb-6">
      {list?.map((city, index) => {
        const isActive = activeValue.toLowerCase() === city.toLowerCase();
        const item = `${capitalized(metal)} rate in ${capitalized(city)}`;

        return (
          <Item
            key={city}
            cityName={item}
            isActive={isActive}
            link={`/${basePath}-${city}`}
            isLastItem={index === list.length - 1}
          />
        );
      })}
    </div>
  );
};

export { BorderedList };
